<template>
  <b-card class="evaluation-container mb-5" body-class="p-4">
    <b-form-group
      :label="trans('streams.feedback.title')"
      label-class="h6"
      v-slot="{ ariaDescribedby }"
    >
      <div class="text-center pt-2">
        <b-form-radio-group
          v-model="feedback"
          :aria-label="trans('streams.feedback.title')"
          :aria-describedby="ariaDescribedby"
          button-variant="outline-primary"
          buttons
        >
          <b-form-radio
            name="good-button"
            value="good"
            class="evaluation-button mr-3 d-flex justify-content-center align-items-center"
          >
            <b-icon-hand-thumbs-up class="evaluation-icon" alt="good" />
          </b-form-radio>
          <b-form-radio
            name="bad-button"
            value="bad"
            class="evaluation-button d-flex justify-content-center align-items-center"
          >
            <b-icon-hand-thumbs-down class="evaluation-icon" alt="bad" />
          </b-form-radio>
        </b-form-radio-group>
        <h6
          v-if="feedback"
          :key="`feedback-${feedback}`"
          class="mt-3"
          role="log"
          aria-live="polite"
        >
          {{ trans("streams.feedback.thanks") }}
        </h6>
      </div>
    </b-form-group>
    <div class="ml-4 pl-4 border-left" v-if="feedback === 'bad'">
      <b-form-group
        :label="trans('streams.feedback.comment')"
        label-for="textarea-evaluationblock"
        label-class="h6"
        class="mb-0"
      >
        <b-form-textarea
          id="textarea-evaluationblock"
          v-model="text"
          rows="3"
          max-rows="6"
          aria-multiline="true"
        ></b-form-textarea>
      </b-form-group>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "EvaluationBlock",
  data() {
    return {
      feedback: "",
      text: "",
    };
  },
  methods: {
    onFeedback() {
      this.$emit("onFeedback", { feedback: this.feedback, text: this.text });
    },
  },
  watch: {
    feedback: function () {
      this.onFeedback();
    },
    text: function () {
      this.onFeedback();
    },
  },
};
</script>

<style scoped lang="scss">
.evaluation-container {
  border: 1px solid rgba($color-dark-600, 0.5);
  border-radius: 0.8rem;
}

.evaluation-button {
  border-radius: 50% !important;
  height: 42px;
  width: 42px;

  .evaluation-icon {
    width: 20px;
    height: 20px;
  }
}
</style>
